/**
 * Mirrors WebApi Models.Common.NewViewerBackend.KollelFolderManagementTabType (HAT-1446 phase 6) —
 * the status tabs of the admin "תיקיות בקשה לאישור" screen. One tab per KollelFolderStatus.
 */
export enum KollelFolderManagementTabType {
  /** ממתין לאישור ועדת רווחה */
  PendingApproval = 1,
  /** אושר */
  Approved = 2,
  /** נדחה */
  Rejected = 3,
  /** בוטל */
  Cancelled = 4,
}
